import { render } from "./NewsView.vue?vue&type=template&id=01cb4951"
import script from "./NewsView.vue?vue&type=script&lang=js"
export * from "./NewsView.vue?vue&type=script&lang=js"

import "./NewsView.vue?vue&type=style&index=0&id=01cb4951&lang=css"

import exportComponent from "D:\\도연희\\vuestudy\\vuestx\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__